import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { PurchaseOrderStatus } from './api';

/**
 * One status, one colour, everywhere it appears.
 *
 * The colours carry the distinction that matters at a glance: blue for orders still being worked,
 * green for goods arrived, grey for finished with. `partially_received` is deliberately a different
 * colour from `received` — "some of it turned up" and "all of it turned up" are the two states a
 * buyer chases, and reading them as the same shade is how a short delivery gets missed.
 */
const COLOURS: Record<PurchaseOrderStatus, string> = {
  open: 'gray',
  issued: 'blue',
  partially_received: 'yellow',
  received: 'green',
  closed: 'dark',
  cancelled: 'red',
};

export function PurchaseOrderStatusBadge({ status }: { status: PurchaseOrderStatus }) {
  const { t } = useTranslation();
  return (
    <Badge color={COLOURS[status] ?? 'gray'} variant="light">
      {t(`purchaseOrders.statuses.${status}`)}
    </Badge>
  );
}
